// thousand
const K = 1000;
// million
const M = 1000 * K;
// billion
const B = 1000 * M;
export function getNoun(number, one, two, five) {
  let n = Math.abs(number);
  n %= 100;
  if (n >= 5 && n <= 20) {
    return five;
  }
  n %= 10;
  if (n === 1) {
    return one;
  }
  if (n >= 2 && n <= 4) {
    return two;
  }
  return five;
}

export const dateToISO = (dateTime) => {
  const [date, time] = dateTime.split(' ');
  let str = '';
  if (time) {
    str = `${date}T${time}`;
  }
  return str;
};

export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let r = (Math.random() * 16) | 0;
    let v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const split = (value) => {
  let rub = Math.trunc(value);
  let kop = Math.round((value - rub) * 100)
    .toString()
    .padStart(2, '0');

  let parts = [];
  if (rub >= B) parts.push(Math.trunc(rub / B));
  if (rub >= M) parts.push(Math.trunc((rub % B) / M));
  if (rub >= K) parts.push(Math.trunc((rub % M) / K));
  parts.push(Math.trunc(rub % K));

  parts = parts.map((part, i) => (i > 0 ? part.toString().padStart(3, '0') : part.toString()));

  return {parts, kop};
};
export function formatCurrency(value) {
  if (isNaN(value)) return '';
  let {parts, kop} = split(value);
  let formatted = parts.join(' ');
  if (kop !== '00') formatted += `,${kop}`;
  return formatted;
}
